import { DomainRedirects } from './DomainRedirects';

const ASRouter = (props) => DomainRedirects(props);

export default ASRouter;
